import { Record } from 'immutable';

const ManagerRecord = Record({
  name: '',
  team: '',
});

export default class Manager extends ManagerRecord {
  static deserialize(jsonObject = {}) {
    return new Manager(jsonObject);
  }
}
